import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";

export class PaymentChangePanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, useXsolla: Boolean = false, onRobokassaCallback: () => unknown, onXsollaCallback: () => unknown) {
        super(scene, canvas, Tr('smena.sposoba.oplaty'));

        this.setDepth(3000);

        let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        let title = TextUtils.addTextByFamily(scene, Tr('vi.pitaetes.smenit.sposob.oplaty'),
            0, -110, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);


        let paymentMethod = Tr('robokassa.label') + ' ' + Tr('payment.method.recommended');

        if (useXsolla) {
            paymentMethod = Tr('xsolla.label');
        }

        let currentPaymentText = Tr('current.payment.method') + ' ' + paymentMethod;

        let info = TextUtils.addTextByFamily(scene, currentPaymentText,
            0, title.getBottomCenter().y! + 80, '#716f6a', 15, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        this.add(info);


        let robokassaButton = new SquareButton(scene, -100, 135, 0, Keys.UI_ART_PALE_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_ROBOKASSA_LOGO, Tr('robokassa.label'), false, 80, 80);

        let xsollaButton = new SquareButton(scene, 100, 135, 0, Keys.UI_ART_PALE_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_XSOLLA_LOGO, Tr('xsolla.label'), false, 80, 80);

        robokassaButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (onRobokassaCallback != null) {
                this.close();
                onRobokassaCallback();
            }
        });

        xsollaButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (onXsollaCallback != null) {
                this.close();
                onXsollaCallback();
            }
        });

        this.add([title, robokassaButton, xsollaButton]);
    }


}
